// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-info-footer[data-v-18c1f3ba]{margin-top:5px}.error-info-footer *[data-v-18c1f3ba]{font-size:12px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.4;letter-spacing:normal;text-align:left;color:#7c8b91}.error-info-footer .error *[data-v-18c1f3ba]{color:#ff5b61!important}.error-info-footer .error.warning *[data-v-18c1f3ba]{color:#debd30!important}", ""]);
// Exports
module.exports = exports;
